package org.hs_soft.runmynesto.pages.home.sub_page.options.mvi

import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.app_constants.LoadAppConstant
import org.hs_soft.runmynesto.domain.model.home.options.OptionInfoHeaders
import org.hs_soft.runmynesto.domain.model.home.options.cash_flow.app_config_model.GetAppConfig
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.CashRegisterConfigHeaders
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.CashRegisterConfigHardwareHeaders
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.adyen_store.AdyenStores
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.list_device.DeviceItem
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.tse_location.CashRegister
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api.CashRegisterConfig
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.operation.get_cash_register_config.GetCashRegister
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.apaleo_properties.ListApaleoProperty
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.virtual_card.virtual_card_config.GetVirtualCardConfig
import org.hs_soft.runmynesto.domain.model.home.options.export.apaleo_payment_method.ApaleoPaymentMethods
import org.hs_soft.runmynesto.domain.model.home.options.export.apaleo_sub_account.ApaleoSubAccounts
import org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info.CashRegisterGlobal
import org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.menu_card_model.MenuCardModel
import org.hs_soft.runmynesto.domain.model.home.options.operation.option_model.OptionModel
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Furniture
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.RestaurantProject
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room
import org.hs_soft.runmynesto.domain.model.home.options.single_sale_group.GetSalesGroup
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list.Ingredients
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.sale_group.SaleItem
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.printer_location.PrinterLocation
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.ChildrenX
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.ChildrenXX
import org.w3c.files.File

data class OptionsState(
    val selectedTab: OptionInfoHeaders = OptionInfoHeaders.OPERATION,
    val firstPageActive:Boolean=true,
    val selectedCashRegisterConfigTab: CashRegisterConfigHeaders =
        CashRegisterConfigHeaders.OPERATION,
    val errorInfo:String?=null,
    val deleteRestaurantFloorLoading:Boolean=false,
    val errorMessage:String?=null,
    val editRestaurantFloorLoading:Boolean=false,
    val deleteRestaurantRoomLoading:Boolean=false,
    val addRestaurantFloorLoading:Boolean=false,
    val selectedFurniture:Furniture?=null,
    val listDevices:List<DeviceItem?>?=null,
    val aydenStores:List<AdyenStores?>?=null,
    val paymentTerminalTypes: List<LoadAppConstant>?=null,
    val tseLocations:List<CashRegister?>?=null,
    val cashRegisterGlobal:CashRegisterGlobal?=null,
    val optionCreditCards:List<String?>?=null,
    val apaleoPaymentMethods:List<ApaleoPaymentMethods?>?=null,
    val clearMenuCardDataLoading:Boolean=false,
    val apaleoProperties:List<ListApaleoProperty?> ?=null,
    val apaleoSubAccounts:List<ApaleoSubAccounts?> ?=null,
    val showVirtualCardColorPalletDialog:Boolean=false,
    val selectedColorField:String?=null,
    val virtualCardInfo: GetVirtualCardConfig?=null,
    val selectedCashRegisterConfigData: GetCashRegister?=null,
    val selectedCashRegisterConfigItemId:String?=null,
    val cashList: List<Children> ?= null,
    val appConfig: GetAppConfig?=null,
    val optionModel: OptionModel ?= null,
    val isLoading:Boolean=false,
    val productSalesGroup:List<SaleItem> ?=null,
    val selectedSaleGroup: GetSalesGroup?=null,
    val searchedSaleValue:String="",
    val isSaleGroupNameSortedAsc:Boolean=true,
    val isSaleGroupNumberSortedAsc:Boolean=true,
    val showSaleGroupNumberSortIcon:Boolean=false,
    val newCashRegisterConfigData: CashRegisterConfig? = null,
    val showSaleGroupTitleSortIcon:Boolean=false,
    val saleGroupSearchValue:String="",
    val newRecordName:String?=null,
    val newRecordNumber:String="",
    val isAddNewRecordSubmitClickable:Boolean=false,
    val addSalesGroupLoading:Boolean=false,
    val showAddSaleGroupRecordDialog:Boolean=false,
    val showPrinterLocationRecordDialog:Boolean=false,
    val printersLocation:List<PrinterLocation?> ? =null,
    val printerLocationIndex:Int?=null,
    val showGoogleWalletDialog:Boolean=false,
    val showAppleWalletDialog:Boolean=false,
    val priceLevels:List<String?> ?=null,
    val selectedPriceLevelIndex:Int?=null,
    val selectedOffice:Children?=null,
    val selectedRegion:ChildrenX?=null,
    val selectedBranch:ChildrenXX?=null,
    val showGenerateAIMenuCardDialog:Boolean=false,
    val isMenuCardAIGeneratorLoading:Boolean=false,
    val menuCardAIGenerated:MenuCardModel = MenuCardModel(
        categories = mutableListOf(),
        items = mutableListOf()
    ),
    val menuCardPDFFilesUploaded:Int=0,
    val menuCardImageFilesUploaded:Int=0,
    val menuCardSelectedFiles:List<File>? = emptyList(),
    var productItemID:Int=0,
    val productItemPropertyKey:String="",
    val productItemPropertyValue:String="",
    val restaurantProjects:List<RestaurantProject?> ?=null,
    val selectedRestaurantProject: RestaurantProject?=null,
    val showChooseRestaurantTableColorDialog:Boolean=false,
    val selectedRestaurantDesignTableColor:String?=null,
    val selectedRestaurantRoom:Room ?=null,
    val showAddFloorDialog:Boolean=false,
    val showEditFloorDialog:Boolean=false,
    val showDeleteRestaurantRoomDialog:Boolean=false,
    val showDeleteRestaurantFloorDialog:Boolean=false,
    val selectedFloorId:String ?=null,
    val selectedRoomId:String?=null,
    val dataLoadingProgressTitle:String="",
    val selectedFloorNumberForEdit:Int?=null,
    val showAddNewDeviceToCashRegistersDialog:Boolean=false,
    val areTabsClickable:Boolean=true,
    val addNewPrinterLocationLoading:Boolean=false,
    val addNewCashRegisterLoading:Boolean=false,
    val ingredients:List<Ingredients> ?=null,
    val templateCategoryList:List<TemplateCategoryModel> = emptyList(),
    val templateCategoryListDropDown:MutableList<TemplateCategoryModel> = mutableListOf(),
    val selectedCashRegisterConfigHardwareTab: CashRegisterConfigHardwareHeaders =
        CashRegisterConfigHardwareHeaders.RECEIPT_PRINTER,
)